import { WHEEL_OFFSET_DEG } from '../components/mystery-wheel/SvgWheel';

export const degToRad = (deg: number) => (deg * Math.PI) / 180;

/**
 * Generates an SVG path description for an arc.
 * @param x - The x-coordinate of the center of the arc.
 * @param y - The y-coordinate of the center of the arc.
 * @param radius - The radius of the arc.
 * @param startAngle - The starting angle of the arc (in degrees).
 * @param endAngle - The ending angle of the arc (in degrees).
 * @returns The SVG path description for the arc.
 */
export const describeArc = (x: number, y: number, radius: number, startAngle: number, endAngle: number) => {
    const start = {
        x: x + radius * Math.cos(degToRad(startAngle)),
        y: y + radius * Math.sin(degToRad(startAngle)),
    };
    const end = {
        x: x + radius * Math.cos(degToRad(endAngle)),
        y: y + radius * Math.sin(degToRad(endAngle)),
    };
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    return [
        `M ${x} ${y}`,
        `L ${start.x} ${start.y}`,
        `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${end.x} ${end.y}`,
        'Z',
    ].join(' ');
};

export const getTargetAngle = (multipliers: number[], targetMultiplier: number) => {
    const sliceAngle = 360 / multipliers.length;
    const matchingIndices = multipliers.reduce<number[]>((acc, value, index) => {
        if (value === targetMultiplier) {
            acc.push(index);
        }
        return acc;
    }, []);

    // If there are duplicates, choose a random one
    const randomIndex = matchingIndices[Math.floor(Math.random() * matchingIndices.length)];

    // Calculate the target angle for the selected slice
    const baseTargetAngle = randomIndex * sliceAngle;

    // Rotate to bring the random position to the top (-90 degrees)
    return -baseTargetAngle - WHEEL_OFFSET_DEG;
};
